<template>
  <div class="testing">
    <div class="paper">
      <h2 class="paper_title">{{ $route.query.chapterTitle }}</h2>
      <div class="info_row">
        <span style="margin-right: 70px">总题数:{{ totalCount }}道</span>
        <span
          >总分数:<span style="color: #ff0000; margin: 0 8px">100</span>分</span
        >
      </div>

      <div class="main">
        <div class="idxs">
          <span>题号：</span>
          <p
            class="idx"
            :class="{ alreadyDo: ids.find((id) => id == item.questionId) }"
            v-for="(item, idx) in questionList"
            :key="idx"
            @click="
              activeIdx = idx;
              $refs.carousel.setActiveItem(idx);
            "
          >
            {{ idx + 1 }}
          </p>
        </div>
        <el-progress
          class="progress"
          type="circle"
          :percentage="progress"
        ></el-progress>
        <el-carousel
          ref="carousel"
          indicator-position="none"
          arrow="never"
          :loop="false"
          :autoplay="false"
        >
          <el-carousel-item
            v-for="(question, idx) in questionList"
            :key="question.questionId"
          >
            <h3 class="type_title">
              {{ titleText(question.type) }}
              <span style="margin-left: 5px"
                >{{ totalScore(question.type) }}分</span
              >
            </h3>
            <component
              :is="question.type"
              :question="question"
              :idx="idx + 1"
              @chooseAnswer="setAnswers"
            ></component>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="btns">
        <el-button
          v-show="activeIdx"
          class="btn"
          type="primary"
          @click="
            activeIdx--;
            $refs.carousel.prev();
          "
          >上一题
        </el-button>
        <el-button class="btn" type="primary" @click="onSubmit">
          {{ activeIdx + 1 == totalCount ? "提交" : "下一题" }}</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { submitTest } from "@/api/chapter";
import RADIO from "@/components/questionTemplates/radio";
import CHECKBOX from "@/components/questionTemplates/checkbox";
import BOOLEAN from "@/components/questionTemplates/boolean";
export default {
  name: "testing",
  components: {
    RADIO,
    CHECKBOX,
    BOOLEAN,
  },
  data() {
    return {
      testAnswers: {},
      radio: [],
      checkbox: [],
      boolean: [],
      activeIdx: 0,
      progress: 0,
      ids: [],
    };
  },
  created() {
    if (this.questionList) this.classify(this.questionList);
  },
  computed: {
    questionList() {
      return this.$store.state.test.questionList;
    },
    totalCount() {
      return this.questionList ? this.questionList.length : 0;
    },
  },
  watch: {
    questionList(val) {
      this.classify(val);
    },
  },
  methods: {
    // 题目分类
    classify(arr) {
      this.radio = [];
      this.checkbox = [];
      this.boolean = [];
      arr.forEach((item) => {
        switch (item.type) {
          case "RADIO":
            if (this.isInArray(this.radio, item)) return;
            this.radio.push(item);
            break;
          case "CHECKBOX":
            if (this.isInArray(this.checkbox, item)) return;
            this.checkbox.push(item);
            break;
          case "BOOLEAN":
            if (this.isInArray(this.boolean, item)) return;
            this.boolean.push(item);
            break;
        }
      });
    },
    // 是否存在
    isInArray(arr, item) {
      return arr.some((e) => e.questionId === item.questionId);
    },
    // 题目标题
    titleText(type) {
      if (type == "RADIO") {
        return "单选题";
      } else if (type == "CHECKBOX") {
        return "多选题";
      } else if (type == "BOOLEAN") {
        return "判断题";
      }
    },
    // 单类型题总分
    totalScore(type) {
      if (type == "RADIO") {
        return this.sum(this.radio);
      } else if (type == "CHECKBOX") {
        return this.sum(this.checkbox);
      } else if (type == "BOOLEAN") {
        return this.sum(this.boolean);
      }
    },
    // 计算总分
    sum(arr) {
      if (arr)
        return Number(
          arr
            .reduce(function (prev, curr) {
              return curr.score + prev;
            }, 0)
            .toFixed(2)
        );
    },
    // 答案集合
    setAnswers(answer) {
      if (Object.values(answer) == "") {
        delete this.testAnswers[Object.keys(answer)[0]];
        this.ids = this.ids.filter((i) => i != Object.keys(answer)[0]);
      } else {
        this.testAnswers = {
          ...this.testAnswers,
          ...answer,
        };
      }

      // 答题进度
      this.progress = parseInt(
        (Object.values(this.testAnswers).length / this.totalCount) * 100
      );
      for (let prop in this.testAnswers) {
        this.ids.push(prop);
      }
    },
    // 提交
    onSubmit() {
      if (this.activeIdx + 1 != this.totalCount) {
        this.activeIdx++;
        this.$refs.carousel.next();
      } else {
        let num = this.totalCount - Object.values(this.testAnswers).length;
        let tips = num > 0 ? `还有${num}题未作答，` : "";
        this.$confirm(`${tips}确定要提交吗？`)
          .then(() => {
            // console.log(this.testAnswers);
            let arr = [];
            for (let prop in this.testAnswers) {
              arr.push({
                answer: this.testAnswers[prop].split(","),
                questionId: prop,
              });
            }

            this.$loading.show();
            submitTest({
              classChapterId: this.$route.query.classChapterId,
              answers: arr,
            }).then((res) => {
              this.$loading.hide();
              if (res.code == 0) {
                this.$message.success("提交成功");
                this.$emit("updateTest");
                this.$router.push({
                  path: "/courseDetail/testing/reviewTest",
                  query: {
                    ...this.$route.query,
                  },
                });
              } else {
                this.$message.error(res.msg);
              }
            });
          })
          .catch(() => {});
      }
    },
  },
};
</script>

<style lang="less" scoped>
.testing {
  height: 100%;
  .paper {
    position: relative;
    margin: 10px auto;
    padding: 40px 60px;
    width: 1200px;
    height: calc(100% - 20px);
    overflow: auto;
    background-image: url("../../assets/images/question_bg.png");
    background-size: cover;
    background-repeat: no-repeat;

    &::-webkit-scrollbar {
      width: 4px;
      background-color: #f5f5f5;
    }

    &::-webkit-scrollbar-track {
      box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      border-radius: 10px;
      background-color: #f5f5f5;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
      background-color: #c8c8c8;
    }

    .main {
      position: relative;
      min-height: calc(100% - 20px - 80px - 27px - 42px);
      .idxs {
        margin-top: 20px;
        .idx {
          display: inline-block;
          margin-right: 10px;
          width: 30px;
          height: 30px;
          line-height: 30px;
          text-align: center;
          color: #409eff;
          border: solid 1px #409eff;
          border-radius: 5px;
          cursor: pointer;
          &.alreadyDo {
            color: #fff;
            background-color: #409eff;
          }
        }
      }
      .progress {
        position: absolute;
        top: 120px;
        right: 40px;
      }
    }

    .paper_title {
      text-align: center;
    }

    .info_row {
      margin-top: 10px;
      padding-bottom: 20px;
      font-size: 16px;
      color: #666;
      text-align: center;
      border-bottom: dashed 1px #ddd;

      .start_time {
        margin: 0 100px;
      }
    }

    .type_title {
      margin-top: 20px;
      font-size: 20px;
    }

    .btns {
      margin-top: 20px;
      text-align: center;

      .btn {
        margin-right: 30px;
        width: 144px;
        height: 42px;
        font-size: 16px;
        border-radius: 10px;
        box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.15);
      }
    }
  }
}
</style>